import api from "@/api/api-v1-config";

export async function getTenantListAxios() {
    return await api.get("tenants");
}

export async function postTenantAxios(tenant) {
    return await api.post("tenants", tenant);
}

export async function putTenantAxios(tenant) {
    return await api.put("tenants", tenant);
}

export async function putTenantDetailsAxios(tenant) {
    return await api.put("tenants/updatetenantdetails", tenant);
}

export async function getTenantByIdAxios(id) {
    return await api.get("tenants/" + id);
}

export async function activateTenantAxios(id) {
    return await api.post("tenants/" + id + "/activate");
}


export async function deactivateTenantAxios(id) {
    return await api.post("tenants/" + id + "/deactivate");
}

export async function getTenantFCByModuleAxios(moduleName) {
    return await api.get("tenants/getfieldconfig?ModuleName=" + moduleName);
}

export async function putTenantFCAxios(payload) {
    return await api.put("tenants/modifytenantfieldconfig", payload);
}

export async function getUserLogsAxios(TableName, PrimaryKey){
    return await api.get(`tenants/logs?TableName=${TableName}&PrimaryKey=${PrimaryKey}`);
}

export async function putModuleConfigAxios(payload){
    return await api.put("tenants/putmoduleconfig", payload);
}

export async function postSignatureAxios(payload) {    
    return await api.post("tenants/signature", payload);
}

export async function getSignatureIDAxios(moduletype, id) {    
    return await api.get(`tenants/getsignaturebyid?ModuleType=${moduletype}&id=${id}`);
}